import {
  GET_OVERTIME_VOLUNTARY_ERROR,
  GET_OVERTIME_VOLUNTARY_PENDING,
  GET_OVERTIME_VOLUNTARY_SUCCESS,
  SAVE_OVERTIME_VOLUNTARY_ERROR,
  SAVE_OVERTIME_VOLUNTARY_PENDING,
  SAVE_OVERTIME_VOLUNTARY_SUCCESS,
  SET_OVERTIME_VOLUNTARY_DATA,
} from './constants';

const INIT_STATE = {
  dataList: [],
  isGetOvertimeVoluntaryPending: false,
  errorMessage: '',
  saveOvertimeVoluntaryStatus: '',
  saveOvertimeVoluntaryErrorMessages: '',
};

export default (localState = INIT_STATE, action) => {
  switch (action.type) {
    case GET_OVERTIME_VOLUNTARY_PENDING: {
      return {
        ...localState,
        isGetOvertimeVoluntaryPending: true,
      };
    }
    case GET_OVERTIME_VOLUNTARY_SUCCESS: {
      return {
        ...localState,
        isGetOvertimeVoluntaryPending: false,
      };
    }
    case GET_OVERTIME_VOLUNTARY_ERROR: {
      return {
        ...localState,
        isGetOvertimeVoluntaryPending: false,
      };
    }
    case SET_OVERTIME_VOLUNTARY_DATA: {
      return {
        ...localState,
        dataList: action.payload,
      };
    }
    case SAVE_OVERTIME_VOLUNTARY_PENDING: {
      return {
        ...localState,
        saveOvertimeVoluntaryStatus: 'PENDING',
        saveOvertimeVoluntaryErrorMessages: '',
      };
    }
    case SAVE_OVERTIME_VOLUNTARY_SUCCESS: {
      return {
        ...localState,
        saveOvertimeVoluntaryStatus: 'SUCCESS',
      };
    }
    case SAVE_OVERTIME_VOLUNTARY_ERROR: {
      return {
        ...localState,
        saveOvertimeVoluntaryStatus: 'ERROR',
        saveOvertimeVoluntaryErrorMessages: action.payload,
      };
    }
    default:
      return { ...localState };
  }
};
